/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { ComponentInterface } from '../../canvas-common/interfaces/component.interface';
import { TicketContainer, TICKET_CHANGE_EVENTS } from '../tickets/TicketContainer';
import { Texture } from 'pixi.js-legacy';
import { TicketComponentHelper } from './TicketComponentHelper';
import { Side } from '@touchplan/common';
import { Ticket } from '@touchplan/common';
import { FancyText } from '@appCanvasCommon/fontpath/FancyText';
import { HighResolutionText } from '@appCanvasCommon/text/HighResolutionText';
import { planRendererInfo } from '@appCanvasCommon/core/RendererInfo';
import { CanvasAngularLand } from 'src/app/app-data/interfaces/canvas-angular-land';
import { EventMode } from '@appCanvasCommon/events/event-mode.enum';

export class TicketCrewSize extends TicketComponentHelper implements ComponentInterface {
	private _value: FancyText | HighResolutionText;
	constructor(texture: Texture, canvasAngularLand: CanvasAngularLand, ticketContainer: TicketContainer) {
		super(texture, canvasAngularLand, ticketContainer);

		this.width = 44;
		this.height = 35;

		// Fall back to Canvas if WebGL is not available
		if (planRendererInfo.isWebGL()) {
			this._value = new FancyText('Roboto');
			this._value.active = true;
			this._value.visible = true;

			this._value.x = this.texture.width + 17;
			//this._value.y = -6;
			this._value.fontSize = 96; // 32px * 3x scale factor = 96;
		} else {
			this._value = new HighResolutionText('');
			this._value.active = true;
			this._value.visible = true;

			this._value.x = this.texture.width + 20;
			this._value.style.fontSize = 96; // 32px * 3x scale factor = 96;
		}

		this._value.enableTrimText = false;

		this.addChild(this._value);

		// Offset 15 pixels from the left edge
		this.x = 15;

		ticketContainer.on(TICKET_CHANGE_EVENTS.CHANGED, this.onChanged);
		this.onChanged(ticketContainer, null);
		this.eventMode = EventMode.None;
	}

	private onChanged = (ticketContainer: TicketContainer, old) => {
		const data: Ticket = ticketContainer.getData();
		const layout = ticketContainer.getLayout();
		this.renderable = data.view.side === Side.PULL;
		if (this.renderable) {
			this.tint = ticketContainer.liveRoleTextColor;

			this._value.text = '' + data.view.liveCrewSize;
			this._value.tint = ticketContainer.liveRoleTextColor;
			this._value.calculateText();

			// padding-bottom: 20px
			// Align to bottom-left, then offset the height and 20
			this.y = layout.height - this.height - 10;
		}
	};

	public override destroy(options?) {
		this.ticket.off(TICKET_CHANGE_EVENTS.CHANGED, this.onChanged);
		super.destroy(options);
	}
}
